export default "__VITE_ASSET__DG1W6bAy__"